// extracted by mini-css-extract-plugin
export default {"App":"App_App__DC6aY","AppTable":"App_AppTable__HpIlq","AppTableRow":"App_AppTableRow__wwrM5","AppTableData":"App_AppTableData__xQ8bq"};